const constants = {
  API_URI: process.env.REACT_APP_API_URI || 'http://localhost:3000',
  API_ASSITED: process.env.REACT_APP_API_URI_SUMMARY ,
  AUTH_TOKEN: process.env.REACT_APP_AUTH_TOKEN || 'auth-token',
  IS_DUOC_DESIGN: process.env.REACT_APP_UNIVERSITY === 'DUOC',
  HIDDEN_COMPONENT_ON_LTI: 'HIDDEN_COMPONENT_ON_LTI'
};

export default constants;
